<template>
  <div
    class="table-row-detail-container loading-wrapper"
    :class="{ 'is-loading' : objectFormDisabled }"
  >
    <div class="grid-x grid-padding-x">
      <div class="cell" style="flex: 1;">
        <dl class="stacked">
          <dt>{{ $t('form.project.location') }}</dt>
          <dd>{{ object.location.company_name }}</dd>
          <dt>{{ $t('form.city') }}</dt>
          <dd>{{ object.address.city }}</dd>
          <dt>{{ $t('form.project.pm') }}</dt>
          <dd>{{ object.account.profile.firstname }} {{ object.account.profile.lastname }}</dd>
          <dt>{{ $t('mobile') }}</dt>
          <dd>{{ object.account.profile.communication.mobile }}</dd>
          <dt>{{ $t('phone') }}</dt>
          <dd>{{ object.account.profile.communication.phone }}</dd>
          <dt>{{ $t('mail') }}</dt>
          <dd>{{ object.account.profile.communication.email }}</dd>
        </dl>
      </div>
      <div class="cell" style="width: 110px; min-width: 110px;">
        <span class="table-status table-status--right">
          <span class="status-icon status-icon--busy">{{ $t('status.busy') }}</span>
          <span class="table-label">{{ $helpers.formatNumber(layersStats.finished) }}</span>
          <span class="table-description">{{ $t('qm') }}</span>
        </span>
        <span class="table-status table-status--right">
          <span class="status-icon status-icon--open">{{ $t('status.open') }}</span>
          <span class="table-label">{{ $helpers.formatNumber(layersStats.open) }}</span>
          <span class="table-description">{{ $t('qm') }}</span>
        </span>
      </div>
      <div class="cell" style="width: 256px; min-width: 256px;">
        <dl>
          <dt>{{ $t('form.project.layer_hole') }}</dt>
          <dd>{{ object.layer_hole ? $t('yes') : $t('no') }}</dd>
          <dt>{{ $t('form.project.layer_tok') }}</dt>
          <dd>{{ object.layer_tok ? $t('yes') : $t('no') }}</dd>
          <dt>{{ $t('form.project.layer_width') }}</dt>
          <dd>
            <template
              v-if="object.showLayerWidth"
            >{{ object.layer_width_min }} - {{ object.layer_width_max }} {{ $t('m') }}</template>
          </dd>
        </dl>
      </div>
    </div>
    <template v-if="object.layers.length >= 1">
      <div class="form">
        <div class="form-group" v-for="(layer, index) in object.layers" :key="index">
          <v-projects-table-detail-row-layer
            :layerType="layer"
            :layerValue="layer.layer_log"
            :cancelled="objectFormCancelled"
            @onFinishLayer="onFinishLayer"
          />
        </div>
        <div class="form-group">
          <template
            v-if="$store.getters.userHasPermission('project_qm_update') && !objectFormCancelled"
          >
            <button
              role="button"
              type="submit"
              class="button"
              :title="$t('form.submit.save')"
              :disabled="objectFormDisabled"
              @click="onSubmitObject"
            >{{ $t('form.submit.save') }}</button>
          </template>
        </div>
      </div>
    </template>
    <div class="loading-message" v-if="objectFormDisabled">{{ $t('results_loading') }}</div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

import ProjectsTableDetailRowLayer from "./ProjectsTableDetailRowLayer";

export default {
  props: {
    value: {
      type: Object,
      default: []
    }
  },
  data() {
    return {
      objectError: null,
      objectFormDisabled: false,
      objectFormCancelled: false,
      object: this.value,
      layersStats: {
        total: 0,
        finished: 0,
        open: 0,
        layers: {
          default: 0,
          addition: 0
        }
      }
    };
  },
  components: {
    vProjectsTableDetailRowLayer: ProjectsTableDetailRowLayer
  },
  created: function() {
    this.onUpdateObject();
  },
  methods: {
    onUpdateObject: function() {
      this.object = JSON.parse(JSON.stringify(this.object));

      if (this.object.status === "cancelled") {
        this.objectFormCancelled = true;
      }

      this.object.showLayerWidth = false;

      if (
        parseInt(this.object.layer_width_min) > 0 ||
        parseInt(this.object.layer_width_max) > 0
      ) {
        this.object.showLayerWidth = true;
      }

      if (this.object.layers.length > 0) {
        this.object.layers.forEach(
          function(layer, index) {
            this.object.layers[index].layer_log = {
              qm: "",
              date: {
                date: this.$moment().format("YYYY-MM-DD hh:mm:ss")
              }
            };
          }.bind(this)
        );
      }

      this.onUpdateLayersStats();
    },
    onSubmitObject: function(event) {
      if (event) {
        event.preventDefault();
      }

      let promise = this.$api
        .clearParams()
        .post(
          "projects/" + this.object.id + "/update",
          this.onCalculatedObject()
        );

      promise
        .then(
          (response => {
            this.objectFormDisabled = false;

            this.$emit("update", response.data.data);
          }).bind(this)
        )
        .catch(
          (error => {
            this.objectFormDisabled = false;
          }).bind(this)
        );

      this.objectFormDisabled = true;
    },

    onCalculatedObject: function() {
      var object = JSON.parse(JSON.stringify(this.object));
      if (object.layers.length > 0) {
        object.layers.forEach(
          function(layer, index) {
            if (layer.layer_log && parseInt(layer.layer_log.qm) >= 1) {
              layer.layer_logs.push(layer.layer_log);
            }
          }.bind(this)
        );
      }

      return object;
    },
    onUpdateLayersStats: function() {
      this.layersStats.total = this.object.stats.qm.total;
      this.layersStats.finished =
        this.object.stats.qm.total - this.object.stats.qm.open;
      this.layersStats.open = this.object.stats.qm.open;
    },
    onFinishLayer: function(layer) {
      if (this.object.layers.length > 0) {
        this.object.layers.forEach(
          function(item, index) {
            if (item.id === layer.id) {
              this.object.layers[index] = layer;
            }
          }.bind(this)
        );
      }
      this.onSubmitObject();
    }
  }
};
</script>